import { type TextColorToken } from '@betterment/samba-react';
import { Box, Icon } from '@betterment/samba-react';

import { type ThemedAsset } from '../components/themed-image/ThemedImage';
import { ThemedImage } from '../components/themed-image/ThemedImage';

export const iconNameForSymbol = (symbol: string | null | undefined) => {
  if (symbol && symbol === 'CASH_USD') {
    return 'Cash';
  }

  return 'PieAlt';
};

export const weightDisplayFor = (weight: number) => {
  const thresholdValue = 0.1;

  if (weight < thresholdValue) {
    return `<${thresholdValue.toFixed(1)}`;
  }

  return weight.toFixed(1);
};

export const textColorFor = (value: number, opts?: { allowCritical: boolean }): TextColorToken => {
  if (value > 0) return 'text.success';
  if (value < 0) return opts?.allowCritical ? 'text.critical' : 'text.weak';
  return 'text';
};

export const numberSignFor = (value: number): string => {
  return value > 0 ? '+' : '';
};

export const formattedNumberCompact = (number: number) => {
  const compactFormat = new Intl.NumberFormat('en-US', {
    notation: 'compact',
    compactDisplay: 'short',
    maximumSignificantDigits: 3,
  });

  return compactFormat.format(number);
};

export type IconDisplayForSecurityProps = {
  symbol: string | null | undefined;
  logo?: ThemedAsset | null;
};

export const iconDisplayForSecurity = ({ symbol, logo }: IconDisplayForSecurityProps) => {
  const defaultIconElement = (
    <Icon color="currentColor" name={iconNameForSymbol(symbol)} aria-label="default icon" size="small" />
  );
  let iconElement = defaultIconElement;

  if (logo) {
    const altAttribute = `${symbol ?? 'Security'} logo`;
    iconElement = <ThemedImage css={{ width: 'size.300', height: 'size.300' }} alt={altAttribute} themedAsset={logo} />;
  }

  return (
    <Box
      css={{
        color: 'primitives.black',
        backgroundColor: 'primitives.grey.10',
        borderRadius: 'medium',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'size.450',
        height: 'size.450',
        overflow: 'hidden',
      }}
    >
      {iconElement}
    </Box>
  );
};
